export default __webpack_public_path__ + "static/media/62.c2386c83.mp3";